import { FormHelperText, FormHelperTextProps } from '@mui/material';
import { MuiTelInputCountry, MuiTelInputProps } from 'mui-tel-input';
import { Controller, useFormContext } from 'react-hook-form';
import PhoneField from '~/components/PhoneField/PhoneField';
import { getErrorKey } from '~/helpers/utils';

type IFormPhoneFieldProps = Omit<
  MuiTelInputProps,
  'dataTestId' | 'errorDataTestId' | 'errorMessage' | 'label' | 'name' | 'onChange' | 'value'
> & {
  name: string;
  errorTouchedOnly?: boolean;
  dataTestId?: string;
  label?: string;
  isTableInput?: boolean;
  allowedCountries?: MuiTelInputCountry[];
};

export const FormPhoneField = ({
  name,
  errorTouchedOnly,
  dataTestId,
  label,
  ...props
}: IFormPhoneFieldProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState, formState }) => {
        const showError =
          (errorTouchedOnly
            ? fieldState.isTouched
            : fieldState.isTouched || formState.isSubmitted) && !!fieldState.error;
        const errorText = showError ? (fieldState.error?.message as string) : '';
        const errorDataTestId = [field.name, getErrorKey(errorText)].join('-');

        return (
          <PhoneField
            {...props}
            {...field}
            label={label ?? ''}
            dataTestId={dataTestId ?? field.name}
            slots={{
              formHelperText: (props: FormHelperTextProps) => (
                <FormHelperText {...props} data-testid={errorDataTestId} />
              ),
            }}
            value={field.value || ''}
            onChange={field.onChange}
            helperText={errorText}
            error={!!errorText}
          />
        );
      }}
    />
  );
};
